/**
 * Mascarade Noire — Le Bestiaire
 * Cartes à collectionner : léger effet 3D à la souris, retournement pour
 * choisir la taille, ajout au panier.
 *
 * - La face cachée est "inert" : jamais atteinte au clavier par erreur.
 * - L'ajout passe par les actions panier standard du thème (le compteur et le
 *   tiroir panier se mettent à jour), avec repli sur l'API /cart/add.js.
 * - Aucun effet de mouvement si "réduire les animations" est actif.
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    try {
      var stored = localStorage.getItem('mn-reduced-motion');
      if (stored === 'true') return true;
      if (stored === 'false') return false;
    } catch (e) {}
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initTilt(card) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var inner = card.querySelector('.mn-beast-card__inner');
    if (!inner) return;

    card.addEventListener('pointermove', function (e) {
      if (card.classList.contains('is-flipped') || prefersReducedMotion()) return;
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      inner.style.transform = 'rotateY(' + (x * 10).toFixed(2) + 'deg) rotateX(' + (-y * 10).toFixed(2) + 'deg)';
    });
    card.addEventListener('pointerleave', function () {
      if (card.classList.contains('is-flipped')) return;
      inner.style.transform = '';
    });
  }

  function setStatus(back, message) {
    var status = back.querySelector('[data-mn-beast-status]');
    if (status) status.textContent = message || '';
  }

  function initFlip(card, variantsByHandle) {
    var inner = card.querySelector('.mn-beast-card__inner');
    var front = card.querySelector('[data-mn-beast-front]');
    var back = card.querySelector('[data-mn-beast-back]');
    var frontCta = front ? front.querySelector('[data-mn-beast-flip]') : null;
    var flipBtns = card.querySelectorAll('[data-mn-beast-flip]');
    if (!inner || !front || !back) return;

    function setFlipped(flipped) {
      card.classList.toggle('is-flipped', flipped);
      inner.style.transform = flipped ? 'rotateY(180deg)' : '';
      if (flipped) {
        back.removeAttribute('inert');
        front.setAttribute('inert', '');
      } else {
        front.removeAttribute('inert');
        back.setAttribute('inert', '');
      }
      if (frontCta) frontCta.setAttribute('aria-expanded', flipped ? 'true' : 'false');
    }

    flipBtns.forEach(function (btn) {
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        var next = !card.classList.contains('is-flipped');
        if (next) {
          if (back.dataset.mnOffrande === 'true') {
            setupOffrandeAdd(back);
          } else {
            populateSizes(back, variantsByHandle);
          }
        }
        setFlipped(next);
        // Déplace le focus du bon côté de la carte, une fois l'animation lancée.
        window.requestAnimationFrame(function () {
          if (next) {
            var target =
              back.querySelector('.mn-beast-size:not([disabled])') ||
              back.querySelector('[data-mn-beast-add]:not([disabled])') ||
              back.querySelector('.mn-beast-card__more');
            if (target) target.focus({ preventScroll: true });
          } else if (frontCta) {
            frontCta.focus({ preventScroll: true });
          }
        });
      });
    });

    card.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && card.classList.contains('is-flipped')) {
        setFlipped(false);
        if (frontCta) frontCta.focus({ preventScroll: true });
      }
    });
  }

  function addToCart(variantId, back, addBtn) {
    addBtn.disabled = true;
    addBtn.textContent = 'Ajout en cours…';
    setStatus(back, '');

    var actions = window.Shopify && window.Shopify.actions;
    var request;

    if (actions && typeof actions.updateCart === 'function') {
      request = actions
        .updateCart(
          { lines: [{ merchandiseId: String(variantId), quantity: 1 }] },
          { event: { context: 'standard-action' } }
        )
        .then(function (result) {
          if (result && result.userErrors && result.userErrors.length) {
            throw new Error(result.userErrors[0].message || 'add-to-cart-failed');
          }
          if (typeof actions.openCart === 'function') {
            actions.openCart();
          }
        });
    } else {
      request = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      }).then(function (res) {
        if (!res.ok) throw new Error('add-to-cart-failed');
        return res.json();
      });
    }

    return request
      .then(function () {
        addBtn.textContent = '✓ Ajouté au panier';
        setStatus(back, 'Ajouté à ton panier.');
        setTimeout(function () {
          addBtn.disabled = false;
          addBtn.textContent = 'Ajouter encore';
        }, 2500);
      })
      .catch(function () {
        addBtn.disabled = false;
        addBtn.textContent = 'Réessayer';
        setStatus(back, "Oups, l'ajout n'a pas fonctionné. Réessaie ou ouvre la fiche produit.");
      });
  }

  function setupOffrandeAdd(back) {
    var addBtn = back.querySelector('[data-mn-beast-add]');
    if (!addBtn || back.dataset.offrandeInit === 'true') return;
    back.dataset.offrandeInit = 'true';

    var variantId = back.dataset.variantId;
    var available = back.dataset.variantAvailable === 'true';

    if (variantId && available) {
      addBtn.disabled = false;
      addBtn.textContent = 'Ajouter au panier';
    } else {
      addBtn.disabled = true;
      addBtn.textContent = 'Rupture de stock';
    }

    addBtn.addEventListener('click', function () {
      if (!variantId || !available) return;
      addToCart(variantId, back, addBtn);
    });
  }

  function populateSizes(back, variantsByHandle) {
    var sizesWrap = back.querySelector('[data-mn-beast-sizes]');
    var addBtn = back.querySelector('[data-mn-beast-add]');
    if (!sizesWrap || !addBtn || sizesWrap.dataset.filled === 'true') return;
    sizesWrap.dataset.filled = 'true';

    var variants = (variantsByHandle && variantsByHandle[back.dataset.productHandle]) || [];
    var selected = null;

    if (!variants.length) {
      sizesWrap.textContent = 'Rupture de stock.';
      return;
    }

    variants.forEach(function (variant) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mn-beast-size';
      btn.textContent = variant.title;
      btn.setAttribute('aria-pressed', 'false');
      if (!variant.available) {
        btn.disabled = true;
        btn.setAttribute('aria-label', variant.title + ' — rupture de stock');
      }
      btn.addEventListener('click', function () {
        selected = variant;
        sizesWrap.querySelectorAll('.mn-beast-size').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        addBtn.disabled = false;
        addBtn.textContent = 'Ajouter la taille ' + variant.title;
        setStatus(back, '');
      });
      sizesWrap.appendChild(btn);
    });

    addBtn.addEventListener('click', function () {
      if (!selected) return;
      addToCart(selected.id, back, addBtn);
    });
  }

  function boot() {
    document.querySelectorAll('[data-mn-bestiaire]').forEach(function (root) {
      if (root.dataset.mnBestiaireInit === 'true') return;
      root.dataset.mnBestiaireInit = 'true';

      var section = root.closest('section');
      var dataScript =
        section && section.parentElement
          ? section.parentElement.querySelector('script[data-mn-bestiaire-products]')
          : null;
      var variantsByHandle = {};
      if (dataScript) {
        try {
          variantsByHandle = JSON.parse(dataScript.textContent || '{}');
        } catch (e) {
          variantsByHandle = {};
        }
      }

      root.querySelectorAll('[data-mn-beast]').forEach(function (card) {
        initTilt(card);
        initFlip(card, variantsByHandle);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
})();
